module.exports = __webpack_public_path__ + "static/media/help-24px.10edf050.svg";